import FeatureCardHome from "./FeatureCardHome";

// Home Page
const HomePage = ({ setActivePage }) => {
  return (
    <div>
      {/* Hero Section */}
      <section
        className="relative bg-amber-50 py-16 md:py-24"
      >
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ backgroundImage: "url('/images/hero-image-1.jpg')" }}
        ></div>

        {/* Overlay (optional darker layer for better readability) */}
        <div className="absolute inset-0 bg-gray-900 opacity-30"></div>

        {/* Content */}
        <div className="relative container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-100 mb-6">
              Connecting Talent with Opportunity
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              We specialize in tech recruitment and custom software development to help your business thrive in the digital age.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button
                onClick={() => setActivePage('services')}
                className="bg-gray-800 text-white px-6 py-3 rounded-md font-medium hover:bg-gray-700 transition-colors">
                Explore Services
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* Features Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">What We Offer</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* <FeatureCard
              icon={<Users className="text-gray-800" />}
              title="Talent Acquisition"
              description="We connect top tech talent with companies looking for the perfect fit for their teams."
            /> */}
            <FeatureCardHome
              imageSrc="/images/talent_acquisition-1.jpg"
              title="Talent Acquisition"
              description="We connect top tech talent with companies looking for the perfect fit for their teams."
            />
            <FeatureCardHome
              // icon={<Briefcase className="text-gray-800" />}
              imageSrc="/images/software-development-1.jpg"
              title="Software Development"
              description="Custom software solutions designed and developed to meet your business needs."
            />
            {/* <FeatureCardHome
              icon={<FileText className="text-gray-800" />}
              title="Career Consulting"
              description="Professional guidance for job seekers looking to advance their careers in tech."
            /> */}
            {/* <FeatureCardHome
              icon={<Users className="text-gray-800" />}
              title="Talent Acquisition"
              description="We connect top tech talent with companies looking for the perfect fit for their teams."
            /> */}
            {/* <FeatureCardHome
              icon={<FileText className="text-gray-800" />}
              title="Career Consulting"
              description="Personalized coaching, resume review, and guidance to help job seekers land their dream roles."
            /> */}
            <FeatureCardHome
              // icon={<Briefcase className="text-gray-800" />}
              imageSrc="/images/outsoursing-1.jpg"
              title="Recruitment Process Outsourcing (RPO)"
              description="End-to-end hiring solutions to help companies scale quickly with the right people."
            />
            <FeatureCardHome
              // icon={<Code className="text-gray-800" />}
              imageSrc="/images/customer-software-1.jpg"
              title="Custom Software Development"
              description="Tailored web and mobile applications built to solve your business challenges efficiently."
            />
            <FeatureCardHome
              // icon={<Rocket className="text-gray-800" />}
              imageSrc="/images/mvp-1.jpg"
              title="MVP for Startups"
              description="We build Minimum Viable Products (MVPs) that help startups launch faster and validate ideas."
            />
            <FeatureCardHome
              // icon={<Settings className="text-gray-800" />}
              imageSrc="/images/technical-team-1.jpg"
              title="Technical Team Augmentation"
              description="Augment your in-house team with our vetted developers, designers, and engineers."
            />
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">What Our Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <p className="text-gray-600 italic mb-4">
                "Techapplics helped us find the perfect developers for our startup. Their understanding of our needs and the tech landscape was impressive."
              </p>
              <p className="font-semibold text-gray-800">— Sarah Johnson, CEO at InnovateTech</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <p className="text-gray-600 italic mb-4">
                "The custom CRM they developed has transformed our customer management process. Highly recommended for any software development needs."
              </p>
              <p className="font-semibold text-gray-800">— Mike Chen, Operations Director at GlobalConnect</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Process Section */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Our Process</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-amber-500 text-4xl mb-4 font-bold">1</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Discovery</h3>
              <p className="text-gray-600">We understand your goals, challenges, and define clear requirements.</p>
            </div>
            <div>
              <div className="text-amber-500 text-4xl mb-4 font-bold">2</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Strategy</h3>
              <p className="text-gray-600">We craft tailored hiring or development plans aligned with your objectives.</p>
            </div>
            <div>
              <div className="text-amber-500 text-4xl mb-4 font-bold">3</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Execution</h3>
              <p className="text-gray-600">We deliver results—whether that’s the right talent or a fully functional product.</p>
            </div>
            <div>
              <div className="text-amber-500 text-4xl mb-4 font-bold">4</div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Support</h3>
              <p className="text-gray-600">Ongoing collaboration, updates, and optimizations to ensure continued success.</p>
            </div>
          </div>
        </div>
      </section>


      {/* CTA Section */}
      <section className="bg-gray-800 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Whether you're looking for top tech talent or need custom software solutions, we're here to help you succeed.
          </p>
          <button
            onClick={() => setActivePage('contact')}
            className="bg-amber-200 text-gray-800 px-8 py-3 rounded-md font-medium hover:bg-amber-300 transition-colors">
            Contact Us Today
          </button>
        </div>
      </section>
    </div>
  );
};

export default HomePage